import { Clock } from 'lucide-react';
import type { ReactElement } from 'react';

export function GameweekBadge(): ReactElement {
  return (
    <div className="flex items-center justify-center gap-2">
      <span className="rounded-md bg-primary/10 border border-primary/20 px-2 py-0.5 text-[11px] font-bold text-primary">
        GW3
      </span>
      <span className="inline-flex items-center gap-1 rounded-md bg-muted/60 border border-border px-2 py-0.5 text-[11px] font-semibold text-muted-foreground">
        <Clock className="h-3 w-3" /> Deadline in 1d 18h
      </span>
    </div>
  );
}
